<template>
    <div class="my-appointments mt-page">
        <h1>{{ $i18n.gt('HEADING_APPOINTMENTS') }}</h1>
        <appointment-calendar :practitioner-view="false"/>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'
import PatientPageMixin from '@/providers/PatientPageMixin'

export default Vue.extend({
    name: 'MyAppointments',
    mixins: [PatientPageMixin]
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

</style>
